'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const it=require('pulsar-utils/dist-es6/it');
const PropertyAggregator=require('pulsar-utils/dist-es6/propertyAggregator');
const AggregationHelpers=require('pulsar-utils/dist-es6/aggregationHelpers');
const DistributionParameters=require('../../../dist-es6/server/services/distributionParameters');

const SpecialAggregates=[
'numPersonsOnDuty',
'maxLastKnownFatigue',
'averageFatigueOnDuty'];let


StatisticsAggregator=function(_PropertyAggregator){_inherits(StatisticsAggregator,_PropertyAggregator);
function StatisticsAggregator(){let fatigueDistributionParameters=arguments.length>0&&arguments[0]!==void 0?arguments[0]:DistributionParameters.DefaultFatigueDistributionParameters;_classCallCheck(this,StatisticsAggregator);var _this=_possibleConstructorReturn(this,
_PropertyAggregator.call(this));

_this._aggregateMap={
numTripsOnDuty:function(vals){return AggregationHelpers.sumOf(vals)},
maxFatigueOnDuty:function(vals){return AggregationHelpers.aggregateSafeMaxOf(vals)},
averageHoursOfSleepPerDay:function(vals){return AggregationHelpers.aggregateSafeAverageOf(vals)}};


_this._fatigueDistributionParameters=fatigueDistributionParameters;return _this;
}StatisticsAggregator.prototype.

aggregate=function aggregate(stats,requiredAggregates){
let[propToPropAggregates,specialAggregates]=_.partition(requiredAggregates,function(a){return!_(SpecialAggregates).includes(a)});

let aggregated=_PropertyAggregator.prototype.aggregate.call(this,stats,propToPropAggregates);

if(_(specialAggregates).includes('numPersonsOnDuty')){
aggregated.numPersonsOnDuty=_(stats).filter(function(s){return s.numDuties>0}).value().length;
}

if(_(specialAggregates).includes('maxLastKnownFatigue')){
aggregated.maxLastKnownFatigue=AggregationHelpers.aggregateSafeMaxOf(stats.map(function(s){return s.lastKnownStatus.fatigue}));
}

if(_(specialAggregates).includes('averageFatigueOnDuty')){

aggregated.averageFatigueOnDuty=this._getAggregateAverageFatigueOnDutyFor(stats);
}

return aggregated;
};StatisticsAggregator.prototype.

_getAggregateAverageFatigueOnDutyFor=function _getAggregateAverageFatigueOnDutyFor(persons){
const accumulatedWeighteds=persons.map(function(p){return p.weightedAverageFatigueOnDuty}).reduce(function(accumulated,current){
accumulated.weight+=current.weight;
accumulated.sum+=current.sum;
return accumulated;
},{weight:0,sum:0});

return StatisticsAggregator.averageFromWeightedAverage(accumulatedWeighteds);
};StatisticsAggregator.

averageFromWeightedAverage=function averageFromWeightedAverage(average){
_.ensureInstanceOf(Object,average);
_.ensureInstanceOf('number',average.weight);
_.ensureInstanceOf('number',average.sum);

if(average.weight===0){
return null;
}
return average.sum/average.weight;
};return StatisticsAggregator}(PropertyAggregator);


module.exports=StatisticsAggregator;
//# sourceMappingURL=statisticsAggregator.js.map
